import { createFileRoute } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader, CTABand } from "@/components/site/Blocks";
import { buildHead } from "@/lib/seo-head";

export const Route = createFileRoute("/es/socios")({
  head: () =>
    buildHead({
      title: "Socios — Agentes, Prestamistas y Profesionales | Simply Approved",
      description:
        "Programa de socios para agentes, prestamistas, gestores de propiedades y profesionales inmobiliarios que trabajan con inversionistas.",
      url: "/es/socios",
      locale: "es",
      keywords: "programa socios préstamos DSCR, agentes inmobiliarios préstamos, socios corredor hipotecario, referir préstamos inversión",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Socios", url: "/es/socios" },
      ],
      service: { name: "Programa de socios para profesionales inmobiliarios" },
    }),
  component: Partners,
});

function Partners() {
  return (
    <SiteShell>
      <PageHero eyebrow="Socios" title="Trabajemos juntos para financiar a los inversionistas." subtitle="Agentes, prestamistas, gestores de propiedades y profesionales: nuestro escritorio DSCR puede ser la solución de financiamiento que sus clientes necesitan." />
      <Section>
        <SectionHeader title="¿A quién servimos?" center />
        <div className="mt-10 grid gap-6 md:grid-cols-3">
          <div className="rounded-2xl border border-border bg-card p-6">
            <h3 className="font-display text-lg font-bold text-foreground">Agentes inmobiliarios</h3>
            <p className="mt-2 text-sm text-muted-foreground">Cierre más propiedades de inversión ofreciendo a sus compradores una opción de financiamiento basada en flujo de caja.</p>
          </div>
          <div className="rounded-2xl border border-border bg-card p-6">
            <h3 className="font-display text-lg font-bold text-foreground">Prestamistas y brokers</h3>
            <p className="mt-2 text-sm text-muted-foreground">Coloque escenarios DSCR, extranjeros, construcción y flip con un socio mayorista que entienda a los inversionistas.</p>
          </div>
          <div className="rounded-2xl border border-border bg-card p-6">
            <h3 className="font-display text-lg font-bold text-foreground">Gestores y contratistas</h3>
            <p className="mt-2 text-sm text-muted-foreground">Conecte a sus clientes inversionistas con opciones de capital para renovar, refinanciar o escalar.</p>
          </div>
        </div>
      </Section>
      <CTABand title="Hable con nuestro equipo de socios" body="Complete el formulario de contacto y mencione que es profesional de referidos." />
    </SiteShell>
  );
}
